import React, { useEffect } from 'react';
import Contact from '../components/Contact';

import business_intelligence_banner from '../assets/business_intelligence_banner.jpg'
import business_intelligence from '../assets/business_intelligence.jpg'

const BusinessIntelligence = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <div className='mt-20 relative'>
        <div className='relative mt-[6rem]'>
          <img
            className='w-full h-[40rem] object-cover blur-sm'
            src={business_intelligence_banner}
            alt='Business Intelligence at Jyotinay Analytics'
          />
          <div className='container mx-auto absolute inset-0 flex flex-col items-center justify-center px-4 text-center'>
            <p className='text-white text-3xl md:text-5xl font-bold'>
              Business Intelligence at Jyotinay Analytics
            </p>
            <p className='text-white text-base md:text-xl mt-4 md:mt-8 max-w-3xl'>
              We empower businesses with real-time insights, custom dashboards, and scalable data solutions. Our Business Intelligence services ensure you always make decisions backed by evidence — not assumptions.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className='container mx-auto mt-12 px-4'>
        <div className='max-w-3xl mx-auto text-left'>
          <p className='text-base md:text-lg leading-relaxed'>
            Jyotinay Analytics helps businesses harness the full potential of Business Intelligence (BI)
            tools and practices to convert raw data into strategic assets. From startups to enterprises,
            we design BI solutions that align perfectly with your operational and decision-making needs.
          </p>

          <img
            className='w-full md:w-[30rem] h-[15rem] object-cover mt-8 rounded-lg shadow-md mx-auto'
            src={business_intelligence}
            alt='Business Intelligence Services'
          />

          {/* Why BI Section */}
          <div className='mt-12'>
            <h2 className='text-xl md:text-2xl font-semibold mb-4'>
              Why Your Business Needs Business Intelligence
            </h2>

            <p className='mb-4 text-base md:text-lg leading-relaxed'>
              Data is only valuable when it leads to actionable outcomes. Business Intelligence transforms your
              fragmented and overwhelming data into structured, visual, and interactive formats — enabling
              faster, smarter decisions across all departments.
            </p>

            <p className='mb-6 text-base md:text-lg leading-relaxed'>
              At Jyotinay Analytics, we implement BI solutions that are modern, intuitive, and built for scale.
              Whether you need executive dashboards, department-specific analytics, or complete data warehousing,
              we’ve got you covered.
            </p>

            <ul className='list-disc ml-6 space-y-2 text-base md:text-lg'>
              <li>Interactive dashboards tailored to your KPIs</li>
              <li>Data warehousing and reporting infrastructure</li>
              <li>Visualization tools like Power BI, Tableau & Looker</li>
              <li>Real-time decision-making using automated reports</li>
              <li>Support for sales, marketing, finance, and operations teams</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Contact Form */}
      <Contact />
    </div>
  );
};

export default BusinessIntelligence;
